// src/components/TimeSlotButton.jsx
import React from 'react';
import { formatUtcToLocalTimeDisplay } from '../utilities/utilities';

function TimeSlotButton({ start, isAvailable, isSelected, onSelect }) {
  return (
    <button
      key={start}
      onClick={() => isAvailable && onSelect(start)}
      disabled={!isAvailable}
      className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ease-in-out transform
        border shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
        ${isAvailable
          ? (isSelected
              ? 'bg-primary text-white border-primary-dark ring-primary scale-105'
              : 'bg-white text-primary border-gray-300 hover:bg-primary-light hover:text-white hover:border-primary focus:ring-primary')
          : 'bg-neutral-light text-neutral-dark cursor-not-allowed opacity-60'}`}
    >
      {formatUtcToLocalTimeDisplay(start)}
    </button>
  );
}

export default TimeSlotButton;
